export const setRefCode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const click_id = urlParams.get('click_id');

  if (click_id && click_id !== 'null') {
    localStorage.setItem('ref_code', click_id);
  }
};
